export default function badRequest(err: {
    status: string | number;
    name: string;
    message: string;
}) {
    // Кадр type=error для соседа при ошибке handshake/RPC.
    return {
        type: "error",
        status: err.status || 500,
        error: {
            name: err.name,
            message: err.message,
        },
    };
}
